import React, { useEffect, useState } from 'react';
import InputFile from './InputFile';

const dropRef = React.createRef();

const DragAndDrop = ({ onFileChange }) => {
  const [boxClass, setBoxClass] = useState('');

  const [files, setFiles] = useState({});

  let dragCounter = 0;

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter++;
    setBoxClass('in');
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter--;
    if (dragCounter > 0) return;
    setBoxClass('');
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const dt = e.dataTransfer;
    dragCounter = 0;

    setFiles(dt.files);
    setBoxClass('');
  };

  useEffect(() => {
    const div = dropRef.current;
    div.addEventListener('dragenter', handleDragIn);
    div.addEventListener('dragleave', handleDragOut);
    div.addEventListener('dragover', handleDrag);
    div.addEventListener('drop', handleDrop);
  }, []);

  const maxSize = 4e6;
  const validTypesMessage =
    '.jpeg, .png, .pdf, .csv, .zip, .xml, .docx, .doc, .odt, .html';

  return (
    <div className={`drag-drop ${boxClass}`} ref={dropRef}>
      <p className="page-subtitle">Drop file here or</p>

      <InputFile
        onChange={onFileChange}
        validTypes="application/zip,application/x-zip-compressed,multipart/x-zip,image/jpeg,image/png,application/pdf,
        .csv,text/csv,.docx,.doc,.odt,text/xml,text/html,text/plain,application/vnd.oasis.opendocument.text,
        application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        validTypesMessage={validTypesMessage}
        droppedFiles={files}
        multiple
        maxSize={maxSize}
      />

      <p className="page-subtitle">
        {`${
          maxSize / 1e6
        } MB file size maximum. Allowed images, documents and zipped files.`}
      </p>
    </div>
  );
};

export default DragAndDrop;
